import { render, staticRenderFns } from "./ItemUpdateDialogSalesData.vue?vue&type=template&id=20cd8182&scoped=true"
import script from "./ItemUpdateDialogSalesData.vue?vue&type=script&lang=ts"
export * from "./ItemUpdateDialogSalesData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cd8182",
  null
  
)

export default component.exports